import { render } from "./protocol_positions.vue?vue&type=template&id=57695a0c&scoped=true"
import script from "./protocol_positions.vue?vue&type=script&lang=js"
export * from "./protocol_positions.vue?vue&type=script&lang=js"

import "./protocol_positions.vue?vue&type=style&index=0&id=57695a0c&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57695a0c"],['__file',"vue/js/components/sale/protocol/create/tabs/protocol_positions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57695a0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57695a0c', __exports__)) {
    console.log('reload')
    api.reload('57695a0c', __exports__)
  }
  
  module.hot.accept("./protocol_positions.vue?vue&type=template&id=57695a0c&scoped=true", () => {
    console.log('re-render')
    api.rerender('57695a0c', render)
  })

}


export default __exports__